<template>
  <SmartLink
    v-if="!route.active"
    :url="route.url"
    :target="route.target"
    :route="route.route"
    :method="route.method"
    :event="route.event"
    :class="clsx('main-menu-button', { 'main-menu-button__active': isHovered(route.name) || isActivePage })"
    @mouseenter="handleMouseEnter(route.name)"
    @mouseleave="handleMouseLeave(route.name)"
    @touchstart="handleMouseEnter(route.name)"
    @touchend="handleMouseLeave(route.name)"
  >
    <div class="main-menu-icon mr-2">
      <component
        :is="route.icon"
        :color="route.active || isHovered(route.name) || isActivePage ? '#0A77FF' : '#78829D'"
      />
    </div>
    {{ route.name }}
  </SmartLink>

  <div v-else class="main-menu-button main-menu-button--active">
    <div class="main-menu-icon">
      <component :is="route.icon" color='#0A77FF' />
    </div>
    {{ route.name }}
  </div>
</template>

<script>
import clsx from 'clsx';
import { mapGetters } from 'vuex';
import { trackHover } from '@/shared/lib/hover';
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    route: {
      type: Object,
      default: null,
      required: true,
    },
  },
  mixins: [ trackHover ],
  components: { SmartLink, },
  computed: {
    ...mapGetters('currentPageModule', ['getActivePage']),
    isActivePage() {
      return this.route?.page && this.route?.page === this.getActivePage;
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.main-menu-button {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #F3F4F6;

  &__active {
    color: #0A77FF;
  }
}
</style>
